<div class="p-grid p-align-start vertical-container mt-1 container-fullsize">
    <!-- <div class="col-md-12 text-center" style="margin-bottom:-30px;">
        <img *ngIf="logo != null"  src="{{logo}}" class="logo" alt="Responsive image">
    </div> -->
    <div class="p-col-12  p-col-align-start  " id= "tableRelatorioVotos">
        <div class="box text-center shadow-lg p-2 mb-2 bg-white rounded" style="min-height: 450px !important;">
            <div class=" mx-3 text-left">
                <span class=" mx-4 text-center font-weight-bolder text-success shadow">
                    <h2> Relatorio de votos {{votosEleicao?.titulo}}
                    <br>
                    </h2>
                </span>
                </div>
                <div class="mx-2 text-right">
                    <button class="btn btn-outline-secondary" (click)="exportParaExcel()" pTooltip="Salvar planilha de votos da eleição">
                        <i class="fas fa-save"></i>
                    </button>
                </div>
            <div class="table-responsive">
                <ul class="px-3">
                    <h4 class="mb-4">Relação de votos</h4>
                <table class="table table-fixed table-bordered">           
                    <thead>
                        <tr>
                            <th scope="col" style="width:15%" *ngIf="rastreabilidade != false">Eleitor</th>
                            <th scope="col" style="width:10%">Plano</th>
                            <th scope="col" style="width:10%">Cargo</th>
                            <th scope="col" style="width:10%">Voto</th>
                            <th scope="col" style="width:35%">Justificativa</th>
                            <th scope="col" style="width:10%">Data</th>
                            <th scope="col" style="width:10%">Hora</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let v of votos" [ngClass]="'bntpo'">
                            <td *ngIf="rastreabilidade != false">{{v.loginEleitor}}</td> <!--Nome eleitor aqui!-->
                            <td>{{v.plano}}</td>
                            <td>{{v.cargo}}</td>
                            <td>{{v.nomeCandidato}}</td> <!--Nome candidato aqui!-->
                            <td>{{v.justificativa}}</td>
                            <td>{{separarDataHora(v).data}}</td>
                            <td>{{separarDataHora(v).hora}}</td>
                        </tr>
                    </tbody>
                </table>
                <hr>
                <div class="mx-3 text-left">
                    <p>Total de votos: {{somaTotalVotos(votosEleicao)}} </p>
                </div>
                </ul>
            </div>
        </div>
    </div>
</div>